/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * An individual link.
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * The request method used to access the link.
     * @type {string}
     * @memberof Link
     */
    method?: string;
    /**
     * The URL for the link. This can be absolute or relative.
     * @type {string}
     * @memberof Link
     */
    href?: string;
    /**
     * If the link expires, this will be the UTC date the link will expire, in ISO 8601 format.
     * @type {string}
     * @memberof Link
     */
    expires?: string;
}

/**
 * Check if a given object implements the Link interface.
 */
export function instanceOfLink(value: object): value is Link {
    return true;
}

export function LinkFromJSON(json: any): Link {
    return LinkFromJSONTyped(json, false);
}

export function LinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): Link {
    if (json == null) {
        return json;
    }
    return {
        
        'method': json['method'] == null ? undefined : json['method'],
        'href': json['href'] == null ? undefined : json['href'],
        'expires': json['expires'] == null ? undefined : json['expires'],
    };
}

export function LinkToJSON(json: any): Link {
    return LinkToJSONTyped(json, false);
}

export function LinkToJSONTyped(value?: Link | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': value['method'],
        'href': value['href'],
        'expires': value['expires'],
    };
}

